module.exports = __webpack_public_path__ + "img/cambridge.8217bd93.png";